module.exports = __webpack_public_path__ + "img/great-dane.0bdd302e.svg";